// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,300;0,400;0,500;0,600;0,800;0,900;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Poppins:wght@300;400;500;600;700;800;900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --yellow: #febc08;
  --rating: #ffe104;
  --pink: #ff75b3;
  --lPink: #FFF1F9;
  --cPink: #FFF8E6;
  --cBgPink: #FFEEF3;
  --dPink: #e20f6f;
  --cSPink: #FF289C;
  --uPTPink: #FFEEF6;
  --blue: #7380ff;
  --dBlue: #264EC8;
  --lblue: #EDEEFD;
  --cBBlue: #C3C5F8;
  --cIBBlue: #E8F2FF;
  --rCBlue: #F3F3FE;
  --uPCBlue: #F4F9FE;
  --white: #ffffff;
  --black: #000000;
  --grey: #8080805e;
  --tGrey: #667085;
  --uPGrey: #323232;
  --pSize: 14px;
  --bHsize: 60px;
  --hSize: 40px;
  --sHsize: 25px;
  --f20: 20px;
  --f15: 14px;
}

body {
  padding: 0px;
  margin: 0px;
  box-sizing: border-box;
  overflow-x: hidden;
}

h1 {
  color: red;
}

h1,
h2,
h3,
h4,
h5,
h6,
p,
a,
span,
li,
button,
td {
  font-family: 'Poppins';
}

a {
  text-decoration: none !important;
}

img {
  width: 100%;
}

.pt-90 {
  padding-top: 90px;
}

.pt-100 {
  padding-top: 100px;
}

.pt-50 {
  padding-top: 50px;
}

.pb-50 {
  padding-bottom: 50px;
}

.pb-70 {
  padding-bottom: 70px;
}

.pb-90 {
  padding-bottom: 90px;
}

.pb-100 {
  padding-bottom: 100px;
}

.pt-40 {
  padding-top: 40px;
}

.pt-30 {
  padding-top: 30px;
}

.pb-40 {
  padding-bottom: 40px;
}

.pd-l {
  padding-left: 10%;
}

.ptb-20 {
  padding: 20px 0px;
}

.p-lr-10 {
  padding: 0 10%;
}

.mt-neg-100 {
  margin-top: -100px;
}

.m-0 {
  margin-bottom: 0px;
}

.mt-15 {
  margin-top: 15px;
}

.mt-35 {
  margin-top: 35px;
}

.mt-40 {
  margin-top: 40px;
}

.ff {
  font-family: "Poppins";
}

.fw-400 {
  font-weight: 400;
}

.fw-500 {
  font-weight: 500;
}

.fw-600 {
  font-weight: 600;
}

.fw-700 {
  font-weight: 700;
}

.fw-800 {
  font-weight: 700;
}

.f-20 {
  font-size: 20px;
  font-size: var(--f20);
}

.f-15 {
  font-size: 15px;
}

.dBlue {
  color: #264EC8;
  color: var(--dBlue);
}

.dPink {
  color: #e20f6f;
  color: var(--dPink);
}

.pink-c {
  color: #ff75b3;
  color: var(--pink);
}

.ratingC {
  color: #ffe104;
  color: var(--rating);
}

.hSize {
  font-size: 40px;
  font-size: var(--hSize);
}

.p-rel {
  position: relative;
}

.sub-head h4 {
  font-weight: 700;
  color: #000000;
  color: var(--black);
  text-transform: uppercase;
}

.ptb-10 {
  padding: 10px 0px;
}

.mt-80 {
  margin-top: 80px;
}

.mt-20 {
  margin-top: 20px;
}

.w-60 {
  width: 60%;
}

.w-10 {
  width: 10%;
}

.w-20 {
  width: 20%;
}

@media (max-width: 767px) {
  p {
    font-size: 14px;
  }

  .pd-l {
    padding-left: 5%;
  }

  .pt-100-mob {
    padding-top: 0px;
  }

  .mt-neg-100-mob {
    margin-top: 15%;
  }

  .p-lr-5-mob {
    padding: 0 5% !important;
  }

  .mt-50-mob {
    margin-top: 50px;
  }
}

.common-btn, .common-btn:hover{
  background: #264ec8;
  border-radius: 40px;
  color: #fff;
}`, "",{"version":3,"sources":["webpack://./src/component/styles.css"],"names":[],"mappings":"AAGA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,cAAc;EACd,aAAa;EACb,cAAc;EACd,WAAW;EACX,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;;;;;;;;;;;;EAYE,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAqB;EAArB,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAmB;EAAnB,mBAAmB;AACrB;;AAEA;EACE,cAAmB;EAAnB,mBAAmB;AACrB;;AAEA;EACE,cAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,cAAoB;EAApB,oBAAoB;AACtB;;AAEA;EACE,eAAuB;EAAvB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAmB;EAAnB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;AACb","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,300;0,400;0,500;0,600;0,800;0,900;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Poppins:wght@300;400;500;600;700;800;900&display=swap\");\n\n\n:root {\n  --yellow: #febc08;\n  --rating: #ffe104;\n  --pink: #ff75b3;\n  --lPink: #FFF1F9;\n  --cPink: #FFF8E6;\n  --cBgPink: #FFEEF3;\n  --dPink: #e20f6f;\n  --cSPink: #FF289C;\n  --uPTPink: #FFEEF6;\n  --blue: #7380ff;\n  --dBlue: #264EC8;\n  --lblue: #EDEEFD;\n  --cBBlue: #C3C5F8;\n  --cIBBlue: #E8F2FF;\n  --rCBlue: #F3F3FE;\n  --uPCBlue: #F4F9FE;\n  --white: #ffffff;\n  --black: #000000;\n  --grey: #8080805e;\n  --tGrey: #667085;\n  --uPGrey: #323232;\n  --pSize: 14px;\n  --bHsize: 60px;\n  --hSize: 40px;\n  --sHsize: 25px;\n  --f20: 20px;\n  --f15: 14px;\n}\n\nbody {\n  padding: 0px;\n  margin: 0px;\n  box-sizing: border-box;\n  overflow-x: hidden;\n}\n\nh1 {\n  color: red;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\np,\na,\nspan,\nli,\nbutton,\ntd {\n  font-family: 'Poppins';\n}\n\na {\n  text-decoration: none !important;\n}\n\nimg {\n  width: 100%;\n}\n\n.pt-90 {\n  padding-top: 90px;\n}\n\n.pt-100 {\n  padding-top: 100px;\n}\n\n.pt-50 {\n  padding-top: 50px;\n}\n\n.pb-50 {\n  padding-bottom: 50px;\n}\n\n.pb-70 {\n  padding-bottom: 70px;\n}\n\n.pb-90 {\n  padding-bottom: 90px;\n}\n\n.pb-100 {\n  padding-bottom: 100px;\n}\n\n.pt-40 {\n  padding-top: 40px;\n}\n\n.pt-30 {\n  padding-top: 30px;\n}\n\n.pb-40 {\n  padding-bottom: 40px;\n}\n\n.pd-l {\n  padding-left: 10%;\n}\n\n.ptb-20 {\n  padding: 20px 0px;\n}\n\n.p-lr-10 {\n  padding: 0 10%;\n}\n\n.mt-neg-100 {\n  margin-top: -100px;\n}\n\n.m-0 {\n  margin-bottom: 0px;\n}\n\n.mt-15 {\n  margin-top: 15px;\n}\n\n.mt-35 {\n  margin-top: 35px;\n}\n\n.mt-40 {\n  margin-top: 40px;\n}\n\n.ff {\n  font-family: \"Poppins\";\n}\n\n.fw-400 {\n  font-weight: 400;\n}\n\n.fw-500 {\n  font-weight: 500;\n}\n\n.fw-600 {\n  font-weight: 600;\n}\n\n.fw-700 {\n  font-weight: 700;\n}\n\n.fw-800 {\n  font-weight: 700;\n}\n\n.f-20 {\n  font-size: var(--f20);\n}\n\n.f-15 {\n  font-size: 15px;\n}\n\n.dBlue {\n  color: var(--dBlue);\n}\n\n.dPink {\n  color: var(--dPink);\n}\n\n.pink-c {\n  color: var(--pink);\n}\n\n.ratingC {\n  color: var(--rating);\n}\n\n.hSize {\n  font-size: var(--hSize);\n}\n\n.p-rel {\n  position: relative;\n}\n\n.sub-head h4 {\n  font-weight: 700;\n  color: var(--black);\n  text-transform: uppercase;\n}\n\n.ptb-10 {\n  padding: 10px 0px;\n}\n\n.mt-80 {\n  margin-top: 80px;\n}\n\n.mt-20 {\n  margin-top: 20px;\n}\n\n.w-60 {\n  width: 60%;\n}\n\n.w-10 {\n  width: 10%;\n}\n\n.w-20 {\n  width: 20%;\n}\n\n@media (max-width: 767px) {\n  p {\n    font-size: 14px;\n  }\n\n  .pd-l {\n    padding-left: 5%;\n  }\n\n  .pt-100-mob {\n    padding-top: 0px;\n  }\n\n  .mt-neg-100-mob {\n    margin-top: 15%;\n  }\n\n  .p-lr-5-mob {\n    padding: 0 5% !important;\n  }\n\n  .mt-50-mob {\n    margin-top: 50px;\n  }\n}\n\n.common-btn, .common-btn:hover{\n  background: #264ec8;\n  border-radius: 40px;\n  color: #fff;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
